import { useSelector } from "react-redux";

export const useNavRoutes = () => {
	const { user: currentUser } = useSelector((state) => state.auth);
	let routes = [];
	if (currentUser) {
		routes.push({
			layout: "",
			path: "/course",
			name: "Courses",
			icon: "fas fa-book",
		});

		routes.push({
			layout: "",
			path: "/certification",
			name: "Certification",
			icon: "fas fa-book",
		});
	}

	// routes.push(
	// 	{
	// 		layout: "",
	// 		path: "/events",
	// 		name: "Events",
	// 		icon: "fas fa-calendar-alt",
	// 	},
	// );

	// routes.push(
	// 	{
	// 		layout: "",
	// 		path: "/upskilling100",
	// 		name: "Upskilling100",
	// 		icon: "fas fa-calendar-alt",
	// 	},
	// );

	return routes;
};
